(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-next-button"] && !Shopify.designMode) return;
  try {
    
// Scroll to next section on click
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.scroll-next-btn');
  if (!btn) return;

  const sections = Array.from(document.querySelectorAll('.shopify-section'));
  const scrollPos = window.scrollY + 5;
  const next = sections.find(sec => sec.offsetTop > scrollPos + 5);

  if (next) {
    next.scrollIntoView({ behavior: 'smooth' });
  } else {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
});

// Hide the button once the footer is in view
document.addEventListener('DOMContentLoaded', function () {
  const btn = document.querySelector('.scroll-next-btn');
  const footer = document.querySelector('.shopify-section-group-footer-group, footer, .footer');
  if (!btn || !footer) return;

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      btn.classList.toggle('is-hidden', entry.isIntersecting);
    });
  }, { threshold: 0.1 });

  observer.observe(footer);
});

  } catch(e) { console.error(e); }
})();
})();
